import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveFiltersComponent } from './active-filters.component';
import { PipesModule } from '../../../utils/pipes/pipes.module';

@NgModule({
  declarations: [ActiveFiltersComponent],
  imports: [CommonModule, PipesModule],
  exports: [ActiveFiltersComponent],
})
export class ActiveFiltersModule {}
